module.exports = __webpack_public_path__ + "static/media/img_jiu.c2d52253.jpg";